import { render } from "./login.vue?vue&type=template&id=5f21ad7c&scoped=true"
import script from "./login.vue?vue&type=script&lang=ts"
export * from "./login.vue?vue&type=script&lang=ts"

import "./login.vue?vue&type=style&index=0&id=5f21ad7c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5f21ad7c"

export default script